import { AtomicOption } from '@df/ui/atomic/atomic.interface';
import range from 'lodash-es/range';

/**
 * Font size options
 */
export function getFontSize(config) {
    let fontSizes = range(1, config.typography.font.size.max ? config.typography.font.size.max + 1 : 0);

    if (config.typography.font.size.custom && Array.isArray(config.typography.font.size.custom)) {
        fontSizes = [...fontSizes, ...config.typography.font.size.custom];
    }

    const fontSize: AtomicOption[] = [];
    fontSizes
        .sort((a, b) => a - b)
        .forEach((i: number) => {
            fontSize.push({
                key: `fs-${i}`,
                title: `${i}`
            });
        });

    return fontSize;
}
